export default __webpack_public_path__ + "locales/az/UploadPanel.json?hash=e1b2027b7b923d0dd80308fc820a8c65";